<template>
    <div>
        <!-- COMPONENTE QUE GERA O LOADING EFECT -->
        <v-overlay :value="overlay || $store.state.loading_pdf">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- FIM COMPONENTE QUE GERA O LOADING EFECT -->

        <!--==== CONTAINER VENDAS ====-->

        <div class="flex flex-col">
            <div class="flex-1 bg-white shadow-xl">
                <!--====== COMBOBOX PARA FAZER O FILTRO DAS INFORMAÇÕES =======-->
                <div class="header-table">
                    <div class="combo_box_container">
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date" rounded
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="date" label="Seleciona a data inicial" readonly v-bind="attrs"
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                                <v-btn text color="primary" @click="salvarData()"> OK </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                    <v-btn v-if="vendas.length && funcaoPorROle.verificarFuncao(16)" small fab color="primary" @click="gerarHTML()"><v-icon>print</v-icon></v-btn>
                </div>
                <!--====== FIM COMBOBOX PARA FAZER O FILTRO DAS INFORMAÇÕES =======-->

                <!-- ===== INÍCIO DA TABELA ==== -->
                <div class="main_table_container">
                    <table class="table-full">
                        <thead class="bg-gray100">
                            <tr>
                                <th class="table_head">#</th>
                                <th class="table_head">Meios de recebimento</th>
                                <th class="table_head">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(venda, index) in vendas" :key="index" v-if="vendas.length">
                                <td class="table_data"> {{ ++index }}</td>
                                <td class="table_data">
                                    <span class="color-table-data">{{ venda.descricao }}</span>
                                </td>

                                <td class="table_data">
                                    <span>{{ utilitarios.IntegerToMoneyValueFatura(venda.total) }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div  class="semPagamentos" v-if="!vendas.length">
                        <p>Dados não encontrado!</p>
                    </div>
                </div>
                <!-- ===== FIM DA TABELA ==== -->

                <!--==== CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
                <div class="totaisContainer" v-if="vendas.length">
                    <div>
                        <span class="align-totais">Total Iliquido:</span>
                        <span class="text-bold totais-font-size"> {{utilitarios.IntegerToMoneyValueFatura(totaisObject.iliquido) }}</span>
                    </div>
                    <div>
                        <span class="align-totais">Total Pago</span>
                        <span class="text-bold totais-font-size"> {{utilitarios.IntegerToMoneyValueFatura(totaisObject.total) }}</span>
                    </div>
                </div>
                <!--====  FIM CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->

                
            </div>
        </div>
    </div>
</template>
    
<script>
import _axios from '../../plugins/axios';
import utilitarios from '../../plugins/utilitarios';
import impressaoService from '../../services/impressaoService';
import funcaoPorROle from '../../utilitarios/funcao.untilitario'
const ls = require('local-storage');
import Swal from 'sweetalert2';
export default {
    name: 'listarVendas',
    data: () => ({
        utilitarios: utilitarios,
        funcaoPorROle: funcaoPorROle,
        vendas: [],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        config: null,
        baseUrl: '',
        templateFull: null
    }),

    props: {
        funcionario: null,
    },
    
    computed: {
        licencaExpirada() {
            return ls.get('licencaExpirada')
        },
        
        usuario() {
            return ls.get('nomeUsuario')
        },

        totaisObject() {
            let totais = { iliquido: 0, total: 0}
            this.vendas.forEach(element => {
                totais.iliquido += (element.iliquido === 'N/A' || element.iliquido === null || element.iliquido === undefined) ? 0 : utilitarios.MoneyValueToInteger(element.iliquido)
                totais.total += (element.total === 'N/A') ? 0 : utilitarios.MoneyValueToInteger(element.total)
            });
            return totais
        }
    },

    created() {
        this.config = ls.get('configuracaoinstituicao');
        this.getUrlImpressao(); 
        this.pesquisarVendas();
        this.getTemplateRelatorio();
    },

    methods: {
       async getUrlImpressao() {
            this.overlay = true;
            try {
                this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
            } catch (error) {
                Swal.fire('Error', 'Ocorreu um erro processando o servidor de impreção', 'error');
            } finally {
                this.overlay = false;
            }
        },

        async getTemplateRelatorio() {
            try {
                this.overlay = true;
                this.templateFull = await _axios.get('/obterRelatorioByDescricao/fi').then((res) => res.data[0]);
            } catch (error) {
                utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante o carregamento do pdf do relatório!');
            } finally {
                this.overlay = false;
            }
        },

        async pesquisarVendas() {
            try {
                this.overlay = true;
                this.vendas = await _axios.get(`/listarVendasFuncionario/${this.funcionario.pkUsuario}/${this.date}`).then((res) => res.data);
            } catch (error) {
                Swal.fire('Error', 'Ocorreu um erro durante a listagem dos pagamentos!', 'error');
            } finally {
                this.overlay = false;
            }
        },

        salvarData() {
            this.$refs.menu.save(this.date)
            this.pesquisarVendas()
        },

        gerarHTML() {
            if (this.licencaExpirada) {
                Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info');
            } else {
                try {
                    this.$store.state.loading_pdf = true;

                    let template = this.templateFull.documento;
                    let relatorioDados = '';

                    this.vendas.forEach(element => {
                        let interacao1 = this.templateFull.documentoiteracao1;
                        interacao1 = interacao1.replace('{{descricao}}', element.descricao);
                        interacao1 = interacao1.replace('{{totalFormaPagamento}}', this.utilitarios.IntegerToMoneyValueFatura(element.total));
                        relatorioDados += interacao1;
                    })

                    let dadoss = {
                        '{{instituicao}}': this.config.nome,
                        '{{data}}': this.date,
                        '{{author}}': ls.get('nomeUsuario'),
                        '{{dataActual}}': this.data_hora(),
                        '{{funcionario}}': this.funcionario.nomeUsuario,
                        '{{dados}}' : relatorioDados,
                        '{{oTotal}}' : this.utilitarios.IntegerToMoneyValueFatura(this.totaisObject.total)
                    }

                    const expressaoRegular = new RegExp(Object.keys(dadoss).join("|"), "g");
                    template = template.replace(expressaoRegular, (match) => dadoss[match]);



                    let header = ` `;
                    let dados = ``;
                    let total = this.utilitarios.IntegerToMoneyValueFatura(this.totaisObject.total);
                    let periodo = ` 
                        <table class="table2">
                        <tr>
                            <td>
                                <div>
                                    <span class="cabelhacos_da_pag" style="font-size: 27px;">Resumo de vendas</span>
                                    <span class="cabelhacos_da_pag" style="font-size: 17px;"> ${this.config.descricao}</span>
                                    <span class="cabelhacos_da_pag" style="font-size: 7px;"> Meios de Recebimento</span>
                                </div>
                                <div class="cabecalho_segundo">
                                    <span class="cabelhacos_da_pag" style="font-size: 7px;">Movimentos dos armazens todos</span>
                                    <span class="cabelhacos_da_pag" style="font-size: 7px;">${this.date} e ${this.date}</span>
                                    <span class="cabelhacos_da_pag" style="font-size: 7px;">Autor impressão: ${this.usuario}</span>
                                    <span class="cabelhacos_da_pag" style="font-size: 7px;">Data de impressão: ${this.data_hora()}</span>
                                </div>  
                                <p class="funcionario">${this.funcionario.nomeUsuario}</p>
                            </td>
                        </tr>
                        </table>`
                    header = ` 
                        <th class="primeiro"></th>
                        <th class="text_a_direita" style="font-size: 11px;">MEIOS DE RECEBIMENTOS</th>  
                        <th class="text_a_direita" style="font-size: 11px;">VALOR</th>`
                    this.vendas.forEach(element => {
                        dados += `
                            <tr>
                            <td></td>
                            <td class="text_a_direita"> ${element.descricao}</td>
                            <td class="text_a_direita"> ${this.utilitarios.IntegerToMoneyValueFatura(element.total)} Kz</td>
                            </tr>`
                    })
    
                    let dados2 = `
                    <tr>
                        <td></td>
                        <td class="text_a_direita"> Total</td>
                        <td class="text_a_direita"> ${total} Kz</td>
                    </tr>`
    
                    this.html = `
                        <html>
                        <head>
                            <style>
                            td {
                                padding: 10px 0;
                                font-size: 9px !important;
                            }
                            * {
                                font-family: "Times New Roman", sans-serif;
                                }
    
                                .primeiro {
                                    width: 300px;
                                }
    
                            .cabelhacos_da_pag {
                                display: block;
                                margin-bottom: 0px;
                                text-align: right;
                            }
                            .text_a_direita {
                                text-align: right;
                            }
                            .total_container_grid {
                                text-align: right;
                                background-color: grey;
                                padding: 5px;
                            }
                            .total_container_grid span {
                                font-size: 11px;
                            }
                            .funcionario {
                                font-size: 22px;
                                font-weigth: bold;
                            }
                            .cabecalho_segundo {
                                margin-top: 20px;
                            }
    
                            .table_header {
                                padding: 5px 3px;
                                text-align: center;
                                background-color: #DCDCDC;
                            }
                            .table_data {
                                text-align: center;
                                padding: 5px;
                            }
                            tr td.data_disciplina {
                                text-align: left;
                            }
                            .logo {
                                width: 100%;
                                text-align: center;
                                margin-bottom: 10px;
                            }
                            .logo_img {
                                width:90%;
                                max-width:50px;
                            }
                            
                            .dados_academicos {
                                border-radius: 15px;
                                border: 1px solid #000000;
                                padding: 15px; 
                                font-size:7px
                            }
                            .dados_totais {
                                font-size:7px
                            }
                            .table1 {
                                width: 100%;
                                margin-top: 30px;
                            }
                            .table2 {
                                border: 0px solid black;
                                margin-left: 0px;
                                margin-right: auto;
                                width: 100%
                            }
                            .legenda {
                                margin-top: 20px;
                                font-size: 7px;
                            }
                            .border_on_table {
                                border: 1px solid #000;
                            }
                            table, th, td {
                                border: 0px solid black;
                                border-collapse: collapse;
                                font-size: 5px;
                            }
                            .bold-span {
                                font-weight: bold;
                            }
                            .row_last_table {
                                width: 100%;
                                display: grid;
                                grid-template-columns: 1fr 1fr 1fr;
                            }
                            </style>
                        </head>
                        <body>
                            ${periodo}
                            <table class="table1">
                            <tr>${header}</tr>
                            <tr>${dados}</tr>
                            <tr>${dados2}</tr>
                            </table>
                        </body>
                        </html> `
    
                        let options = {
                            'format': 'A4',
                            'border': {
                                'right': '9mm',
                                'left': '9mm'
                            },
                            'header': {
                                'height': '10mm'
                            },
                            'footer': {
                                'height': '1mm'
                            }
                        }
    
                        impressaoService.htmlToPdf(template, options);
                } catch (error) {
                    this.$store.state.loading_pdf = false;
                    Swal.fire('Erro', 'Ocorreu um erro durante a impressão', 'error');
                }

            }
        },
        data_hora() {
            let data = new Date()
            return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
        }
    }
};
</script>
  
<style scoped>
.combo_box_container {
    display: flex;
    justify-content: space-between;
    width: 250px;
}

.header-table {
    display: flex;
    justify-content: space-between;
    padding: 5px 50px 5px 5px;
}

.table_data {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border: 1px solid #e2e8f0;
    font-size: 0.75rem;
}

.table_head {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border: 1px solid #e2e8f0;
  font-size: 0.75rem;
}

.bg-gray100 {
  background-color: #f3f4f6;
}
.totaisContainer {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  width: 100%;
  padding: 10px;
  background-color: #fff;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 10px;
}

.align-totais {
  margin-left: 15px;
}

.text-bold {
  font-weight: bold;
}

.totais-font-size {
  font-size: 17px;
}

.semPagamentos {
    font-weight: bold;
    text-align: center; 
    height: 30px;
    font-size: 13px;
}

.semPagamentos p {
    line-height: 30px;
}
.table-full {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
  text-align: center;
}
</style>
    